var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('div',{class:_vm.classes,on:{"click":_vm.fadeBanner}},[_vm._v("\n    "+_vm._s(_vm.message)+"\n")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }